export type ThemesListType = typeof themesList;

export const themesList = {
  deepBlueTheme: {
    colorPrimary: '#053170',
    cardShadow: '0 0 10px rgba(255, 140, 0, 0.5)',
    cardGradient:
      'linear-gradient(180deg, rgba(40, 77, 186, 0.8), rgba(13, 51, 111, 0.9))',
    cardTriangle:
      'linear-gradient(307deg, rgba(40, 77, 186, 0.7) 50%, rgba(23, 64, 117, 0.6) 75%, rgba(13, 51, 111, 0.8) 100%)',
    cardTriangleShadow: '0 0 10px rgba(255, 140, 0, 0.5)',
    mainColor: '#FFFFFF',
    colorBgLayout: '#5eaec6',
    colorPrimaryBgHover: '#63a0c0',
    colorBorderSecondary: '#93b1c1',
    tableBorder: '#053170',
    colorBgSpotlight: '#FFFFFF',
    inputBorderColor: '#053170',
    inputColorPrimary: '#053170',
    colorFillContent: '#ffb58a',
    colorFillContentHover: '#f69906',
    colorFillQuaternary: '#c065a2',
    shadow: '0 2px 6px rgba(0,0,0,0.1), 0 1px 3px rgba(5,49,112,0.05)',
    actionButtons: '#053170',
    actionButtonsHover: '#63a0c0',
    logoutBtn: '#053170',
    logoutBtnHover: '#63a0c0',
    baseColor: '#053170',
    midtone1: '#5eaec6',
    midtone2: '#63a0c0',
    warmOverlay: '#ffb58a',
    warmOverlayAlt: '#f69906',
    pinkGradient: '#c065a2',
    overlay1: '#63a0c0',
    overlay2: '#93b1c1',
    smallBase: '#053170',
    smallOverlay1: '#63a0c0',
    smallOverlay2: '#93b1c1',
    microLightPink: '#c065a2',
    microLightOrange: '#f69906',
    needsBlackText: true
  },
  deepNavyTheme: {
    colorPrimary: '#1b1860',
    cardShadow: '0 0 10px rgba(255, 193, 7, 0.5)',
    cardGradient:
      'linear-gradient(180deg, rgba(12, 111, 182, 0.8), rgba(24, 63, 98, 0.9))',
    cardTriangle:
      'linear-gradient(307deg, rgba(12, 111, 182, 0.7) 50%, rgba(1, 81, 122, 0.6) 75%, rgba(24, 63, 98, 0.8) 100%)',
    cardTriangleShadow: '0 0 10px rgba(255, 193, 7, 0.5)',
    mainColor: '#FFFFFF',
    colorBgLayout: '#1a3e5c',
    colorPrimaryBgHover: '#3a68aa',
    colorBorderSecondary: '#44a7fb',
    tableBorder: '#44a7fb',
    colorBgSpotlight: '#E0EBF4',
    inputBorderColor: '#1b1860',
    inputColorPrimary: '#1b1860',
    colorFillContent: '#E0EBF4',
    colorFillContentHover: '#D1E3F0',
    colorFillQuaternary: '#c065a2',
    shadow: '0 2px 6px rgba(0,0,0,0.1), 0 1px 3px rgba(27,24,96,0.05)',
    actionButtons: '#1b1860',
    actionButtonsHover: '#3a68aa',
    logoutBtn: '#1b1860',
    logoutBtnHover: '#3a68aa',
    baseColor: '#1b1860',
    gradientStart: '#3a68aa',
    gradientEnd: '#44a7fb',
    flareOrange: '#f69906',
    flarePink: '#c065a2',
    baseAlt: '#1a3e5c',
    overlay1: '#44a7fb',
    overlay2: '#a470da',
    overlayLine: '#765cc9',
    accent: '#f69906'
  },
  darkUITheme: {
    colorPrimary: '#44a7fb',
    cardShadow: '0 0 10px rgba(255, 127, 80, 0.5)',
    cardGradient:
      'linear-gradient(180deg, rgba(4, 101, 139, 0.8), rgba(21, 192, 244, 0.9))',
    cardTriangle:
      'linear-gradient(307deg, rgba(4, 101, 139, 0.7) 50%, rgba(27, 189, 230, 0.6) 75%, rgba(21, 192, 244, 0.8) 100%)',
    cardTriangleShadow: '0 0 10px rgba(255, 127, 80, 0.5)',
    mainColor: '#ffffff',
    colorBgLayout: '#010405',
    colorPrimaryBgHover: '#3a68aa',
    colorBorderSecondary: '#93b1c1',
    tableBorder: '#3a68aa',
    colorBgSpotlight: '#0b1220',
    inputBorderColor: '#3a68aa',
    inputColorPrimary: '#63a0c0',
    colorFillContent: '#141c2a',
    colorFillContentHover: '#1c2635',
    colorFillQuaternary: '#162b48',
    shadow: '0 6px 24px rgba(0,0,0,.5), 0 2px 8px rgba(68,167,251,.08)',
    actionButtons: '#3a68aa',
    actionButtonsHover: '#2c5280',
    logoutBtn: '#c065a2',
    logoutBtnHover: '#a0548c',
    focusRing: '#44a7fb',
    success: '#238636',
    warning: '#f69906',
    info: '#63a0c0',
    colorAccentPurple: '#A970FF',
    colorAccentCyan: '#2EE6D6',
    colorAccentCoral: '#FF6F61',
    needsBlackText: true
  },
  lightUITheme: {
    colorPrimary: 'rgb(87 113 158)',
    cardShadow: '0 0 10px rgba(87, 113, 158, 0.6)',
    cardGradient:
      'linear-gradient(180deg, rgba(87, 113, 158, 0.8), rgba(55, 80, 120, 0.9))',
    cardTriangle:
      'linear-gradient(307deg, rgb(255 251 255) 50%, rgba(55, 108, 200, 0.5) 75%, rgba(55, 108, 200, 0.7) 100%)',
    cardTriangleShadow: '0 0 15px rgba(0, 191, 255, 0.8)',
    mainColor: '#ffffff',
    colorBgLayout: '#aac0e4',
    colorPrimaryBgHover: 'rgb(99 133 194)',
    colorBorderSecondary: '#A0AEC0',
    tableBorder: 'rgb(99 133 194)',
    colorBgSpotlight: '#FFFFFF',
    inputBorderColor: '#63A0C0',
    inputColorPrimary: '#3A68AA',
    colorFillContent: '#E5E7EB',
    colorFillContentHover: '#D1D5DB',
    colorFillQuaternary: '#D6E4FF',
    shadow: '0 2px 6px rgba(0,0,0,0.1), 0 1px 3px rgba(58,104,170,0.05)',
    actionButtons: 'rgb(87 113 158)',
    actionButtonsHover: 'rgb(99 133 194)',
    logoutBtn: '#C065A2',
    logoutBtnHover: '#A0548C',
    focusRing: 'rgb(87 113 158)',
    colorAccentMint: '#8EE5D1',
    colorAccentWarmYellow: '#FFD75E',
    colorAccentSoftSky: '#B3E5FC',
    colorAccentLavender: '#C7B9FF',
    colorAccentPeach: '#FFBC9A',
    colorAccentAqua: '#7DDFFF',
    colorPrimaryText: '#000000'
  },
  pinkUITheme: {
    colorPrimary: '#C065A2',
    cardShadow: '0 0 10px rgba(152, 251, 152, 0.5)',
    cardGradient:
      'linear-gradient(180deg, rgba(160, 72, 116, 0.8), rgba(174, 69, 151, 0.9))',
    cardTriangle:
      'linear-gradient(307deg, rgba(160, 72, 116, 0.7) 50%, rgba(243, 99, 192, 0.6) 75%, rgba(174, 69, 151, 0.8) 100%)',
    cardTriangleShadow: '0 0 10px rgba(152, 251, 152, 0.5)',
    mainColor: '#ffffff',
    colorBgLayout: '#FFF0F6',
    colorPrimaryBgHover: '#A0548C',
    colorBorderSecondary: '#A0AEC0',
    tableBorder: '#C065A2',
    colorBgSpotlight: '#FFFFFF',
    inputBorderColor: '#C065A2',
    inputColorPrimary: '#C065A2',
    colorFillContent: '#FFD6E0',
    colorFillContentHover: '#FFCCE5',
    colorFillQuaternary: '#F8E6F1',
    shadow: '0 2px 6px rgba(0,0,0,0.1), 0 1px 3px rgba(192,101,162,0.05)',
    actionButtons: '#C065A2',
    actionButtonsHover: '#A0548C',
    logoutBtn: '#C065A2',
    logoutBtnHover: '#A0548C',
    focusRing: '#C065A2',
    colorSoftRoseMint: '#F2B8C6',
    colorPeachGlow: '#FFBFA3',
    colorBlushSky: '#F8CCE8',
    colorAccentLilac: '#D9B8FF',
    colorAccentCoral: '#FF8F87',
    colorAccentGold: '#F6C98B',
    colorPrimaryText: '#000000'
  },
  bluishTheme: {
    colorPrimary: 'rgb(60 81 97)',
    cardShadow: '0 0 10px rgba(60, 81, 97, 0.6)',
    cardGradient:
      'linear-gradient(180deg, rgba(60, 81, 97, 0.8), rgba(49, 69, 83, 0.9))',
    cardTriangle:
      'linear-gradient(307deg, rgb(172 211 223 / 90%) 50%, rgb(130 157 176 / 80%) 75%, rgb(78 79 82) 100%)',
    cardTriangleShadow: '0 0 15px rgba(0, 191, 255, 0.8)',
    mainColor: '#F6F3EE',
    colorBgLayout: 'rgb(191 212 227)',
    colorBgSpotlight: '#FBF9F6',
    tableBorder: '#A0AEC0',
    colorPrimaryBgHover: '#314553',
    colorBorderSecondary: '#CBBFB2',
    inputBorderColor: '#7E919F',
    inputColorPrimary: 'rgb(60 81 97)',
    colorFillContent: '#DCE5EC',
    colorFillContentHover: '#CFD9E1',
    colorFillQuaternary: '#556B79',
    shadow: '0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(60,81,97,0.08)',
    actionButtons: 'rgb(60 81 97)',
    actionButtonsHover: '#314553',
    logoutBtn: 'rgb(60 81 97)',
    logoutBtnHover: '#24343F',
    focusRing: '#7E919F',
    colorPrimaryText: '#ffffff',
    colorAquaGlow: '#9BB7C4',
    colorSoftAzure: '#D8E4EC',
    colorWarmCoral: '#D79A87',
    colorAccentMintWave: '#B8CCC2',
    colorAccentGoldenSand: '#D6BC84',
    colorAccentLavenderMist: '#C8C3D9'
  },
  lilacTheme: {
    colorPrimary: '#9A97D6',
    cardShadow: '0 0 10px rgba(154, 151, 214, 0.6)',
    cardGradient:
      'linear-gradient(180deg, rgba(154, 151, 214, 0.8), rgba(127, 123, 196, 0.7))',
    cardTriangle:
      'linear-gradient(307deg, rgba(154, 151, 214, 0.7) 50%, rgba(127, 123, 196, 0.7) 75%, rgba(184, 181, 232, 0.65) 100%)',
    cardTriangleShadow: '0 0 10px rgba(154, 151, 214, 0.6)',
    mainColor: '#ffffff',
    colorBgLayout: '#E8E9F7',
    colorPrimaryBgHover: '#7F7BC4',
    colorBorderSecondary: '#D8B4FE',
    tableBorder: '#9A97D6',
    colorBgSpotlight: '#FFFFFF',
    inputBorderColor: '#9A97D6',
    inputColorPrimary: '#9A97D6',
    colorFillContent: '#D5D3F0',
    colorFillContentHover: '#E8E9F7',
    colorFillQuaternary: '#c3c1e2',
    shadow: '0 2px 6px rgba(0,0,0,0.08), 0 1px 3px rgba(154,151,214,0.05)',
    actionButtons: '#9A97D6',
    actionButtonsHover: '#7F7BC4',
    logoutBtn: '#9A97D6',
    logoutBtnHover: '#7F7BC4',
    focusRing: '#9A97D6',
    colorAccentPurple: '#7F7BC4',
    colorAccentLavender: '#E9D5FF',
    colorAccentViolet: '#9333EA',
    colorPrimaryText: '#000000'
  },
  turquoiseTheme: {
    colorPrimary: '#0F766E',
    cardShadow: '0 0 10px rgba(20, 184, 166, 0.6)',
    cardGradient:
      'linear-gradient(180deg, rgba(15, 118, 110, 0.8), rgba(20, 184, 166, 0.9))',
    cardTriangle:
      'linear-gradient( 307deg, rgb(191 235 232 / 70%) 50%, rgba(20, 184, 166, 0.6) 75%, rgba(15, 118, 110, 0.8) 100%)',
    cardTriangleShadow: 'rgba(20,184,166,0.4)',
    mainColor: '#ffffff',
    colorBgLayout: '#F0FDFA',
    colorPrimaryBgHover: '#14B8A6',
    colorBorderSecondary: '#99F6E4',
    tableBorder: '#5EEAD4',
    colorBgSpotlight: '#FFFFFF',
    inputBorderColor: '#14B8A6',
    inputColorPrimary: '#0F766E',
    colorFillContent: '#CCFBF1',
    colorFillContentHover: '#99F6E4',
    colorFillQuaternary: '#B8F2E6',
    shadow: '0 2px 6px rgba(0,0,0,0.08), 0 1px 3px rgba(20,184,166,0.08)',
    actionButtons: '#0F766E',
    actionButtonsHover: '#14B8A6',
    logoutBtn: '#0F766E',
    logoutBtnHover: '#115E59',
    focusRing: '#14B8A6',
    colorAccentMint: '#99F6E4',
    colorAccentSeafoam: '#5EEAD4',
    colorAccentAqua: '#67E8F9',
    colorAccentTeal: '#14B8A6',
    colorAccentDeepTeal: '#115E59',
    colorAccentSoftCyan: '#CFFAFE',
    colorPrimaryText: '#000000'
  }
};
